import OutputReport from '@tcc-online/output-report';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import styles from './OutputReportPage.module.scss';
import IReport from '../../types/IReport';
import useAllowedLanguages from '../../hooks/useAllowedLanguages';
import { useDispatch, useSelector } from 'react-redux';
import OutputReportActions from '../../actions/OutputReportActions';
import LanguageSlice from '../../common/slices/LanguageSlice';
import { OUTPUT_REPORT_OLD_ADMIN_URL } from '../../constants/outputReport.constants';

export default function OutputReportPage() {
    const { id } = useParams<{ id: string }>();
    const locale = useSelector(LanguageSlice.state.getLocale);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [report, setReport] = useState<IReport>();

    useAllowedLanguages(report?.languages);

    useEffect(() => {
        return () => {
            stopLoading();
        };
    }, []);

    return (
        <div className={styles.content}>
            <OutputReport
                id={parseInt(id as string)}
                onLoading={startLoading}
                onLoadingEnded={handleLoadEnd}
                locale={locale as string}
                onQueryChange={handleQueryChange}
                query={searchParams.toString()}
                oldAdminUrl={OUTPUT_REPORT_OLD_ADMIN_URL}
            />
        </div>
    );

    function handleQueryChange(query: string | null) {
        if (query !== null) {
            navigate(`?${query}`);
        } else {
            navigate(-1);
        }
    }

    function handleLoadEnd(report?: IReport) {
        if (report) {
            setReport(report);
        }

        stopLoading();
    }

    function startLoading() {
        dispatch(OutputReportActions.setDetailLoading(true));
    }

    function stopLoading() {
        dispatch(OutputReportActions.setDetailLoading(false));
    }
}
